'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Router = require('../../helpers/Router');

var _auth = require('../../redux/modules/auth');

var _QRSignUp = require('./QRSignUp.scss');

var _QRSignUp2 = _interopRequireDefault(_QRSignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logo = require('../../../res/images/logo/stingray_logo_horizontal_white.svg');

var QRSignUp = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, sessionId: state.auth.sessionId };
}, { login: _auth.login, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(QRSignUp, _Component);

  function QRSignUp() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, QRSignUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = QRSignUp.__proto__ || (0, _getPrototypeOf2.default)(QRSignUp)).call.apply(_ref, [this].concat(args))), _this), _this.navLogin = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.QRLogin));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(QRSignUp, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _QRSignUp2.default.qrSignUpPage },
        _react2.default.createElement(_reactHelmet2.default, { title: 'QRSignUp' }),
        _react2.default.createElement(
          'h1',
          { className: _QRSignUp2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.QRSignUp)
        ),
        _react2.default.createElement(_components.QRSteps, { hasBadges: true, step1StingId: _DefaultString.translations.QRSignUpStep1 }),
        _react2.default.createElement(
          'div',
          { className: _QRSignUp2.default.endContainer },
          _react2.default.createElement(
            'div',
            { className: _QRSignUp2.default.options },
            _react2.default.createElement(_components.RememberMe, { className: _QRSignUp2.default.rememberMe }),
            _react2.default.createElement(
              'div',
              { className: _QRSignUp2.default.already, onClick: this.navLogin },
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.AlreadyAccount)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _QRSignUp2.default.logo },
            _react2.default.createElement('img', { src: logo })
          )
        )
      );
    }
  }]);
  return QRSignUp;
}(_react.Component), _class2.propTypes = {
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = QRSignUp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/QRSignUp/QRSignUp.js
// module id = 2016
// module chunks = 0